angular.module("webcomm.constants", [])
.constant("version", "5.20.0");
